import url from 'url'

import _ from 'lodash'
import moment from 'moment-timezone'

import LocalStorageWrapper from '~/lib/LocalStorageWrapper'

const storage = new LocalStorageWrapper()

export function isSignedUriExpired(uri) {
    if (!uri) {
        return true
    }

    const parseQuery = true
    const { query } = url.parse(uri, parseQuery)
    const now = moment()
    const expireDate = query?.Expires
        ? moment.unix(_.toFinite(query?.Expires)).toDate()
        : _.has(query, 'X-Amz-Date')
        ? moment(_.get(query, 'X-Amz-Date')).toDate()
        : null

    if (expireDate && now.isBefore(expireDate)) {
        return false
    }

    return true
}

// FOR TESTING ONLY DO NOT USE
export function _clearAssetUrlStorage() {
    storage.clear()
}

export function getAssetUrl(uri) {
    if (!uri) {
        return null
    }

    const uriWithoutParams = url.format({
        ...url.parse(uri),
        search: undefined,
        query: undefined,
    })
    const savedSignedUrl = storage.getItem(uriWithoutParams)
    const isExpired = isSignedUriExpired(savedSignedUrl)

    if (!isExpired) {
        return savedSignedUrl
    }

    storage.setItem(uriWithoutParams, uri)
    return uri
}
